import { getUrlVariables, lodash, multiAddEventListener, multiRemoveEventListener } from '../../assets/js/helpers';
import ScrollController from '../../assets/js/controllers/scroll';
import SkrolliteController from '../../assets/js/controllers/skrollite';
import Accordion from '../accordion/script';

export default class FiltersReload {

	static selector = '[data-filters-reload]';

	// class variables

	config = {
		debounceDelay: 250
	};

	el = {};

	flags = {

	};

	selectors = {
		group: 'data-filters-reload-group',
		item: 'data-filters-reload-item',
		rebuildContainer: 'data-dynamic-container',
		loadMore: 'data-dynamic-load-more',
		tab: 'data-tab-filter-item'
	};

	states = {
		itemsStandalone: [],
		values: [],
		queryString: null,
		isDynamic: false,
	};

	fetchData = {
		eventListResponse: null,
		eventListData: null,
		regionData: null,
		regionSlug: null,
	};

	debouncers = {
		reload: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			groups: container.querySelectorAll(`[${this.selectors.group}]`),
			items: container.querySelectorAll(`[${this.selectors.item}]`),
			tabs: container.querySelectorAll(`[${this.selectors.tab}]`),
			dynamicContainer: container.querySelector(`[${this.selectors.rebuildContainer}]`),
			loadMoreBtn: container.querySelector(`[${this.selectors.loadMore}]`)
		};

		this.states.isDynamic = this.el.container.hasAttribute('data-filters-reload-dynamically');

		for (let i = 0; i < this.el.items.length; i++) {
			const $item = this.el.items[i];
			if (!$item.closest(`[${this.selectors.group}]`)) {
				this.states.itemsStandalone.push($item);
			}
		}

		this.debouncers.reload = lodash.debounce(this.reloadDebounced.bind(this), this.config.debounceDelay);
		this.debouncers.loadMore = lodash.debounce(this.loadMoreDebounced.bind(this), this.config.debounceDelay);

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
	}

	// event listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.items, 'click', this.#onItemClick);
		multiAddEventListener(this.el.tabs, 'click', this.#onTabClick);
		this.el.loadMoreBtn.addEventListener('click', this.#onMoreClick);
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.items, 'click', this.#onItemClick);
		multiRemoveEventListener(this.el.tabs, 'click', this.#onTabClick);
		this.el.loadMoreBtn.removeEventListener('click', this.#onMoreClick);
	}

	// listener methods

	#onItemClick = (e) => {
		this.debouncers.reload(e, 'filter');
	}

	#onTabClick = (e) => {
		this.debouncers.reload(e, 'tab');
	}

	#onMoreClick = (e) => {
		this.debouncers.loadMore(e, 'loadmore');
	}

	// reload

	reloadDebounced(e, clickedItem) {
		const urlVars = getUrlVariables();
		let queryString = '';

		// Tabs
		for (let i = 0; i < this.el.tabs.length; i++) {
			const $item = this.el.tabs[i];
			const filterType = $item.getAttribute('data-tab-filter-type');
			const filterValue = $item.getAttribute('data-tab-filter-value');
			const isActive = $item.classList.contains('is-active');
			const urlAttribute = `${filterType}=${filterValue}`;

			if (isActive) {
				if (queryString) {
					queryString += `&${urlAttribute}`;
				} else {
					queryString += `?${urlAttribute}`;
				}
			}

			if (urlVars[filterType]) {
				delete urlVars[filterType];
			}
		}

		for (let i = 0; i < this.el.groups.length; i++) {

			const $group = this.el.groups[i];
			const $groupItems = $group.querySelectorAll(`[${this.selectors.item}]`);
			const groupName = $group.getAttribute(this.selectors.group);

			if ($groupItems.length) {

				let groupQueryString = '';
				for (let k = 0; k < $groupItems.length; k++) {
					const $groupItem = $groupItems[k];
					const $input = $groupItem.nodeName === 'input' ? $groupItem : $groupItem.querySelector('input');
					if ($input.checked) {
						if (groupQueryString) {
							groupQueryString += ',';
						}
						groupQueryString += $input.value;
					}
				}

				if (groupQueryString !== '') {
					if (queryString) {
						queryString += `&${groupName}=`;
					} else {
						queryString += `?${groupName}=`;
					}
					queryString += groupQueryString;
				}

				if (urlVars[groupName]) {
					delete urlVars[groupName];
				}
			}
		}

		// items that don't have groups

		for (let i = 0; i < this.states.itemsStandalone.length; i++) {
			const $item = this.states.itemsStandalone[i];
			const $input = $item.nodeName === 'input' ? $item : $item.querySelector('input');
			const inputValue = $input.value;

			if ($input.checked) {
				if (queryString) {
					queryString += `&${inputValue}`;
				} else {
					queryString += `?${inputValue}`;
				}
			}

			if (urlVars[inputValue]) {
				delete urlVars[inputValue];
			}
		}

		// preserve existing url variables

		const urlVarKeys = Object.keys(urlVars);
		for (let i = 0; i < urlVarKeys.length; i++) {
			const urlVarKey = urlVarKeys[i];
			queryString += `&${urlVarKey}=${urlVars[urlVarKey]}`;
		}

		const currentUrl = window.location.href.split('?')[0];

		if (this.states.isDynamic) {
			this.fetchData.regionSlug = getUrlVariables().region;

			// Fetch event list data:
			const temp = this;
			fetch(`/api/events.json${queryString}`, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
				.then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
				.then(response => {
					temp.fetchData.eventListResponse = response;
					if (response.data && response.data.length > 0) {
						temp.fetchData.eventListData = response.data;
						temp.updatePageContent((clickedItem !== 'loadmore'));
					} else {
						temp.fetchData.eventListData = null;
						temp.updatePageContent(true);
					}
				});

			window.history.replaceState(null, null, queryString + window.location.hash);

			if (clickedItem === 'tab' || (clickedItem === 'filter' && e)) {
				this.populateAllFilterCounts();
			}
			this.fetchData.regionSlug = getUrlVariables().region;
		} else {
			window.location = currentUrl + queryString + window.location.hash;
		}
	}

	loadMoreDebounced() {

		// Fetch event list data:
		let queryString = window.location.href.split('?')[1];
		const nextPage = this.el.loadMoreBtn.getAttribute('data-next-page');
		queryString = `/api/events.json?${queryString}&page=${nextPage}`;

		const temp = this;
		fetch(queryString, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
			.then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
			.then(response => {
				temp.fetchData.eventListResponse = response;
				if (response.data && response.data.length > 0) {
					temp.fetchData.eventListData = response.data;
					temp.updatePageContent(false);
				} else {
					temp.fetchData.eventListData = null;
					temp.updatePageContent(true);
				}
			});
	}

	updatePageContent(shouldReplaceHtml) {
		const newListHtml = this.buildNewHtml(this.fetchData.eventListData, this.fetchData.eventListResponse.meta.pagination);

		// Add to or replace event list
		if (shouldReplaceHtml) {
			this.el.dynamicContainer.innerHTML = newListHtml;
		} else {
			this.el.dynamicContainer.querySelector('[data-accordion]').parentNode.insertAdjacentHTML('beforeend', newListHtml);
		}

		// Update "load more" button
		const isLastPage = (this.fetchData.eventListResponse.meta.pagination) ? (this.fetchData.eventListResponse.meta.pagination.current_page === this.fetchData.eventListResponse.meta.pagination.total_pages) : false;
		if (!isLastPage) {
			const nextPage = (this.fetchData.eventListResponse.meta.pagination) ? (this.fetchData.eventListResponse.meta.pagination.current_page + 1) : 2;
			this.el.loadMoreBtn.setAttribute('data-next-page', nextPage);
		}

		// Refresh Skrollite/etc.
		ScrollController.refresh();
		ScrollController.updateChildren();
		SkrolliteController.pageUpdate();

		if (this.el.dynamicContainer.querySelector('[data-accordion]')) {
			// Rebuild Accordion listeners/selectors with new HTML
			const newAccordion = new Accordion(this.el.dynamicContainer.querySelector('[data-accordion]'));
			newAccordion.destroy();
			newAccordion.initialize();
		}

		// Update Maps
		if (this.fetchData.eventListData && (this.fetchData.eventListData.length > 0) && shouldReplaceHtml) {
			const temp = this;
			fetch(`api/eventRegion.json?regionSlug=${this.fetchData.regionSlug}`, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
				.then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
				.then(response => {
					temp.fetchData.eventListResponse = response;
					if (response) {
						temp.fetchData.regionData = response;
						temp.updateMap(temp.fetchData.eventListData, temp.fetchData.regionData);
					} else {
						temp.updateMap(temp.fetchData.eventListData, temp.fetchData.regionData);
					}
				});
		}
	}

	populateAllFilterCounts() {
		const urlVars = getUrlVariables();

		// Tabs Counts
		for (let i = 0; i < this.el.tabs.length; i++) {
			const $item = this.el.tabs[i];
			const filterType = $item.getAttribute('data-tab-filter-type');
			const filterValue = $item.getAttribute('data-tab-filter-value');
			const urlAttribute = `${filterType}=${filterValue}`;

			let countStr = `?${urlAttribute}`;
			for (const key in urlVars) {
				if (typeof urlVars[key] === 'string') {
					countStr += (key !== 'region') ? `&${key}=${urlVars[key]}` : '';
				} else {
					countStr += `&${key}`;
				}
			}
			this.fetchFilterCount(countStr, $item.querySelector('.copy--super'));
		}

		// Event Type/Groups Counts
		for (let i = 0; i < this.el.groups.length; i++) {

			const $group = this.el.groups[i];
			const $groupItems = $group.querySelectorAll(`[${this.selectors.item}]`);
			const groupName = $group.getAttribute(this.selectors.group);

			if ($groupItems.length) {

				for (let k = 0; k < $groupItems.length; k++) {
					const $groupItem = $groupItems[k];
					const $input = $groupItem.nodeName === 'input' ? $groupItem : $groupItem.querySelector('input');

					let groupItemCountQuery = `?${groupName}=${$input.value}`;

					for (const key in urlVars) {
						if (typeof urlVars[key] === 'string') {
							groupItemCountQuery += (key !== 'filters') ? `&${key}=${urlVars[key]}` : '';
						} else {
							groupItemCountQuery += `&${key}`;
						}
					}
					this.fetchFilterCount(groupItemCountQuery, $groupItem.querySelector('.copy--super'));
				}
			}
		}
	}

	fetchFilterCount(queryString, $countEl) {
		// Fetch data:
		fetch(`/api/eventsFilterCount.json${queryString}`, { headers: { 'Content-Type': 'application/json; charset=utf-8' } })
			.then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
			.then(response => {
				if (response.data) {
					$countEl.innerText = (response.data.length < 10) ? `0${response.data.length}` : `${response.data.length}`;
				} else {
					$countEl.innerText = '00';
				}
			});
	}

	updateMap(eventData, regionData) {

		// Clear old Map Markers
		const shouldReplaceIcons = (this.fetchData.eventListResponse && this.fetchData.eventListResponse.meta) ? (!this.fetchData.eventListResponse.meta.pagination) : true;
		if (shouldReplaceIcons || !eventData || eventData.length === 0) {
			for (let i = 0; i < window.markers.length; i++) {
				window.markers[i].setMap(window.map);
			}
			window.markers = [];
		}

		// Populate Map Markers
		const markers = [];
		if (eventData && eventData.length) {
			for (let i = 0; i < eventData.length; i++) {
				markers.push({
					lat: eventData[i].eventCoordinatesLatitude,
					lng: eventData[i].eventCoordinatesLongitude
				});
			}
		}

		// marker image
		const image = {
			url: 'assets/images/events/pin.png',
			scaledSize: new google.maps.Size(47, 39)
		};

		const mapMarkers = [];
		for (let m = markers.length - 1; m >= 0; m--) {
			const markerT = markers[m];
			let isDifferent = true;

			for (let mm = mapMarkers.length - 1; mm >= 0; mm--) {
				const mapMarker = mapMarkers[mm];
				if (markerT !== mapMarker) {
					if (parseFloat(markerT.lat) === parseFloat(mapMarker.lat) && parseFloat(markerT.lng) === parseFloat(mapMarker.lng)) {
						isDifferent = false;
					}
				}
			}
			if ((isDifferent || mapMarkers.length === 0) && markerT.lat && markerT.lng) {
				mapMarkers.push([markerT]);

				const marker = new google.maps.Marker({
					map: window.map,
					animation: google.maps.Animation.DROP,
					clickable: false,
					icon: image,
					position: {
						lat: parseFloat(markerT.lat),
						lng: parseFloat(markerT.lng)
					}
				});
				window.markers.push(marker);
			}
		}

		if (regionData) {
			window.map.setCenter({
				lat: parseFloat(regionData.lat),
				lng: parseFloat(regionData.lng)
			});
			const mapZoom = parseInt(regionData.zoom);
			window.map.setZoom(mapZoom);
		}
	}

	buildNewHtml(eventData, pagination) {

		let newHtml = '';
		if (eventData) {
			newHtml += '<ul data-accordion data-accordion-desktop-enabled>';
			for (let i = 0; i < eventData.length; i++) {
				let startIndex = i + 1;

				if (pagination && pagination.current_page !== 1) {
					const multiplier = ((pagination.current_page - 1) * pagination.per_page);
					startIndex = (i + 1) + multiplier;
				}
				const indexStr = (startIndex < 10) ? `0${startIndex}` : `${startIndex}`;
				const item = this.fetchData.eventListData[i];

				newHtml += `
					<li class="grid-events__item" data-hover-detector data-skrollite>
						<div class="grid-events__item-top" data-accordion-trigger="event_${indexStr}">
							<button class="cta cta-circle-expand grid-events__item-expand-cta is-large" aria-label="Expand Button">
								<span class="a11y">Expand Button</span>
								<figure class="shape-circle-plus cta-circle-expand__icon is-large">
									<figure class="shape-circle-plus__shapes">
										<figure></figure>
										<figure></figure>
									</figure>
									<figure class="shape-circle-plus__outline"></figure>
								</figure>
							</button>
							<div class="grid-events__item-top-meta">
								<span class="copy--meta">— ${indexStr}</span>
								<span class="copy--meta">[${item.eventType}]</span>
							</div>
							<h3 class="grid-events__item-top-heading" data-hover-detector-item>${item.title}</h3>

							<div class="grid-events__item-top-subheading">
								<p class="grid-events__item-top-subheading--city-country large">
									<strong>${item.eventCityCountry}</strong>
								</p>
								<p class="grid-events__item-top-subheading--date-time large">`;
									if (item.eventDateStart === item.eventDateEnd) {
				newHtml += 				`${item.eventDateStart}`;
										if (item.eventTimeStart && item.eventTimeEnd && (item.eventTimeStart !== item.eventTimeEnd)) {
				newHtml += 					`, ${item.eventTimeStart} – ${item.eventTimeEnd}`;
										} else {
				newHtml += 					`, ${item.eventTimeStart}`;
										}
										if (item.eventTimeZone) {
				newHtml += 					`&nbsp;(${item.eventTimeZone})`;
										}
									} else {
				newHtml += 				`${item.eventDateStart} – ${item.eventDateEnd}`;
										if (item.eventTimeStart && item.eventTimeEnd && (item.eventTimeStart !== item.eventTimeEnd)) {
				newHtml += 					`<br />${item.eventTimeStart}} – ${item.eventTimeEnd}`;
										} else {
				newHtml += 					`, ${item.eventTimeStart}`;
										}
										if (item.eventTimeZone) {
				newHtml += 					`&nbsp;(${item.eventTimeZone})`;
										}
									}
				newHtml +=		`</p>
							</div>
						</div>

						<div class="grid-events__item-collapsible" data-accordion-target="event_${indexStr}">
							<div class="grid-events__item-collapsible-content">
								<div class="grid-events__item-collapsible-description">${item.eventDescription}</div>
								<div class="grid-events__item-collapsible-location-host-wrapper">
									<div class="grid-events__item-collapsible-location">
										<strong>Location</strong>
										<p>${item.eventAddress}</p>
									</div>
									<div class="grid-events__item-collapsible-host">
										<strong>Host</strong>
										<p>${item.eventHost}</p>
									</div>
								</div>`;

								if (item.eventHref) {
				newHtml +=			`<a class="cta cta-rect-arrow-right grid-events__item-collapsible-cta is-black is-small" href="${item.eventHref}" target="_blank" aria-label="Learn More">
										<span class="copy--cta-rect">Learn More</span>
										<figure class="cta-rect-arrow-right__arrow">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.4 9.9">
												<polygon points="4.5,0 3.8,0.7 7.5,4.4 0,4.4 0,5.4 7.5,5.4 3.8,9.2 4.5,9.9 9.4,4.9 "></polygon>
											</svg>
										</figure>
										<figure class="cta-rect-arrow-right__arrow-hover">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.4 9.9">
												<polygon points="4.5,0 3.8,0.7 7.5,4.4 0,4.4 0,5.4 7.5,5.4 3.8,9.2 4.5,9.9 9.4,4.9 "></polygon>
											</svg>
										</figure>
										<figure class="cta-rect-arrow-right__background"></figure>
									</a>`;
								}
				newHtml += 	`</div>
						</div>
					</li>`;
			} // end item for loop
			newHtml += '</ul>';

			this.el.loadMoreBtn.removeAttribute('disabled');
			this.el.loadMoreBtn.removeAttribute('style');

		} else {

			newHtml = '<h3>No events found.</h3>';

			this.el.loadMoreBtn.setAttribute('disabled', '');
			this.el.loadMoreBtn.setAttribute('style', 'display:none;');
		}

		return newHtml;
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
